import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const cashtagP2PClientRoutes = [
  {
    id: 'initiate-payment',
    trackingName: 'Initiate Payment',
    path: 'web/view/cashtag/initiate-payment',
    lazy: async () => ({
      Component: (await import('@cash-web/cashtag-p2p-feature-cashtag-page')).JourneyCashtagInitiatePayment,
    }),
    target: 'fullscreen',
  },
] as const satisfies JourneyRoute[]
